<template>
    <div class="risk-banner">
        <slot />
    </div>
</template>

<script>
export default {
    name: "RiskBanner",
}
</script>

<style scoped lang="scss">
.risk-banner {
    display: flex;
    flex-direction: column;
    background: rgba(124, 224, 211, 0.2);
    border: 1px solid $color-teal;
    border-radius: $border-radius;
    padding: 12px 16px;
    font-size: rem(14px);
    font-weight: 600;
    text-decoration: none;

    .x-icon {
        font-size: rem(17px);
    }
}
</style>
